module.exports = "/packs/006-7ef63d59e1230f8a355ab86badc6e3fc.jpg";